<template>
    <div id="paginated" class="z-50"> 
        <div class="hidden w-full grid-cols-1 gap-4 p-2 text-sm font-semibold tracking-wide md:grid md:grid-cols-7 md:pl-20 md:visible xl:gap-8">
            <p class="cursor-pointer " @click="orderBy('name')">Nombre <span class="filter-indicator" v-if="orderedBy=='name'"><template v-if="order=='asc'">▲</template><template v-else>▼</template></span> </p>
            <p class="cursor-pointer " @click="orderBy('price')">Precio <span class="filter-indicator" v-if="orderedBy=='price'"><template v-if="order=='asc'">▲</template><template v-else>▼</template></span> </p>
            <!-- <p>Descripción <span class="filter-indicator" v-if="orderedBy=="><template v-if="order=='asc'">▲</template><template v-else>▼</template></span> </p> -->
            <p>1H</p>
            <p class="cursor-pointer " >24H <span class="filter-indicator" v-if="orderedBy=='increase'"><template v-if="order=='asc'">▲</template><template v-else>▼</template></span> </p>
            <p class="cursor-pointer " >7D <span class="filter-indicator" v-if="orderedBy=='week_increase'"><template v-if="order=='asc'">▲</template><template v-else>▼</template></span> </p>
            <p class="cursor-pointer " @click="orderBy('marketcap')">Valor Mercado <span class="filter-indicator" v-if="orderedBy=='marketcap'"><template v-if="order=='asc'">▲</template><template v-else>▼</template></span> </p>
            <p>Gráfico</p>
        </div>
        <div class="md:hidden">
            <div class="my-5">
                <div>
                    <select class="w-full p-3 border-b-2 md:w-8/12 border-light_gray" name="" id="" :value="orderedBy ? orderedBy+'_'+order : ''" @change="selectOder($event)">
                        <option v-if="serverSorting" value="" disabled>Ordenar productos</option>
                        <option v-for="item in [
                            {id:'marketcap',name:'Marketcap menor a mayor',order:'asc'},
                            {id:'marketcap',name:'Marketcap mayor a menor',order:'desc'},
                            {id:'name',name:'Nombre de A a la Z',order:'asc'},
                            {id:'name',name:'Nombre de Z a la A',order:'desc'},
                            {id:'price',name:'Precio menor a mayor',order:'asc'},
                            {id:'price',name:'Precio mayor a menor',order:'desc'},
                            ]" :key="item.id" :value="item.id+'_'+item.order">{{item.name}}</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="flex" v-if="myList.data!=null" v-for="item in myList.data" :key="item.id">
            <fruit-list-item v-if="showActions&&$page.props.isAdmin==true" :fruit="item" :link="'/admin/fruit/'+item.id" />
            <fruit-list-item v-else :fruit="item" :link="'/fruit/'+item.slug" />
            <div class="w-20 ml-6" v-if="showActions&&$page.props.isAdmin==true">
                <div class="flex pt-10">
                    <img class="w-5 mx-2 transform cursor-pointer hover:scale-90 " src="/images/editar_enriqueto.svg" @click="editItem(item)" alt="">
                    <img class="w-5 mx-2 transform cursor-pointer hover:scale-90 " src="/images/borrar_enriqueto.svg" @click="deleteItem(item)" alt="">
                </div>
            </div>
        </div>
        <Pagination :links="list.links" />
    </div>
</template>

<script>
import FruitListItem from './FruitListItem.vue'
import Pagination from '../Shared/PaginationComponent.vue'
import useApi from '../../Services/useApi'
import {ref} from 'vue'
import { Inertia } from '@inertiajs/inertia'

export default {
    components: {FruitListItem,Pagination},
    props: ['list','showActions','category','serverSorting','currentSort','currentDirection','sortUrl'],
    setup(props,{emit}){
        console.log(props.list);
        const myList = ref(props.list)
        const orderedBy = ref(props.currentSort || (props.serverSorting ? null : 'marketcap'))
        const order = ref(props.currentDirection || 'desc')
        const {orderFruitsBy,orderCategoryFruitsBy} = useApi();
        const deleteItem = (item)=>{
            emit('deleteItem',item)
        }   
        const editItem = (item)=>{
            emit('editItem',item)
        }   
        const selectOder = (event)=>{
            let value_select = event.target.value.split("_")
            order.value = value_select[1]
            orderedBy.value = value_select[0]
            if(props.serverSorting){
                Inertia.get(props.sortUrl || window.location.pathname, {
                    sort: orderedBy.value,
                    direction: order.value,
                }, {
                    preserveScroll: true,
                    replace: true,
                })
                return
            }
            orderFruitsBy(value_select[0],order.value).then((res)=>{
                myList.value = res.fruits
                orderedBy.value = value_select[0]
                console.log(res.fruits)
            })
        }
        const orderBy = (term)=>{
            order.value = orderedBy.value === term && order.value === 'asc' ? 'desc' : 'asc'
            orderedBy.value = term
            if(props.serverSorting){
                Inertia.get(props.sortUrl || window.location.pathname, {
                    sort: term,
                    direction: order.value,
                }, {
                    preserveScroll: true,
                    replace: true,
                })
                return
            }
            if(props.category==0){
                orderFruitsBy(term,order.value).then((res)=>{
                    myList.value = res.fruits
                    orderedBy.value = term
                    console.log(res.fruits)
                })
            }else{
                orderCategoryFruitsBy(props.category,term,order.value).then((res)=>{
                    myList.value = res.fruits
                    orderedBy.value = term
                    console.log(res.fruits)
                })
            }
            
        }  
        return{
            myList,
            deleteItem,
            editItem,
            orderBy,
            orderedBy,
            order,
            selectOder
        }
    }
}
</script>

<style>
select{
    background-color:transparent;
}
</style>
